
<template>
  <div v-if='question.length' class="question-title mt-3">
    <div :class="{ 'question-require': required }">{{ question }}</div>
  </div>
  <div class="relative" :data-testid="testId || undefined">
    <el-date-picker
      v-model="internalValue"
      v-bind="$attrs"
      type="date"
      :class="disabled ? 'bg-[#F2F2F2] text-[rgba(128,128,128,1)] font-normal' : ''"
      :disabled="disabled"
      :editable="false"
      format="MM-DD-YYYY"
      :placeholder="placeholder"
      :clearable="false"
      value-format="YYYY-MM-DD"

      size="large"
      :prefix-icon="null"
      suffix-icon="el-icon-calendar"
      clear-icon=""
      @focus="handleFocus"
      @blur="handleBlur"
      @calendar-change="handleCalendarChange"
      @visible-change="visibleChange"
      @change="handleDate"
      
    />
    <img
      src="@/assets/my-calendar/arrow-down.svg"
      :class="['absolute dropdown-arrow', { 'reverse-icon': isVisible }]"
      alt="arrow-down"
    />
  </div>
</template>

<script>
import moment from 'moment';
export default {
    
  name: 'DatePicker',
  props: {
    // data-testid for the picker wrapper. el-date-picker's root is a fragment, so a
    // data-testid passed through $attrs would be dropped — bind it here instead.
    testId: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },  
    question:{
      type: String,
      default: "Select"
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    default:{
      type: String,
      default: ""
    },
    limit:{
      type: Array,
      default: () => []
    },
  },
  emits: ["handleDate", "update:modelValue"],

  data() {
    return {
      // value:this.default,
      isVisible:false,
     
    };
  },
  // watch:{
  //   default(){
  //     this.value = this.default
  //   }
  // },
  computed: {
    internalValue: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  created(){
    // get default date value
    // this.value = moment.utc(time)
    //   .local().format("YYYY-MM-DD")
  },


  methods: {
    // tmp enable all dates to book
    // disabledDate(currentDate){
    //   const selectedDate = moment(currentDate);
    //   const today = moment().startOf('day');
    //   return selectedDate.isSameOrBefore(today, 'day');
    // },
    // disabledDate(currentDate){
    //   const selectedDate = moment(currentDate);
    //   if(!this.limit.length){
    //     const start = moment().startOf('day');
    //      return selectedDate.isBefore(start, 'day');
    //   }else{
    //     let startLimit = this.limit[0]
    //     let endLimit = this.limit[1]
    //     const start = moment(startLimit)
    //     const end = moment(endLimit)
    //     if(startLimit&&endLimit){
    //       return selectedDate.isBefore(start)|| selectedDate.isAfter(end)
    //     }else if(startLimit){
    //       return selectedDate.isBefore(start)
    //     }else if(endLimit){
    //       return selectedDate.isAfter(end)
    //     }
       
    //   }
    // },
    handleDate(){
      this.isVisible = false
      this.$emit("handleDate", this.internalValue)

    },
    handleFocus(){
      this.isVisible = true
    },
    handleBlur(){
      this.isVisible = false
    },
    handleCalendarChange(){
      this.isVisible = true
    },
    visibleChange(visible){
      this.isVisible = visible
    }


  },
};
</script>

<style scoped>
.question-title {
  font-size: 14px;
  line-height: normal;
  letter-spacing: 0.15px;
}
.question-require::after {
  content: '*';
  color: red;
}
.dropdown-arrow {
  right: 8px;
  top: calc(50% - 1px);
  transform: translateY(-50%);
  transform-origin: center;
  transition: transform 0.3s ease;
  pointer-events: none;
  width: 12px;
  height: 12px;
}

.dropdown-arrow.reverse-icon {
  transform: translateY(-50%) rotate(180deg);
}



::placeholder {
  font-weight: 400;
}

:deep(.el-input__wrapper) {
  padding-right: 12px;
}


</style>

